export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 4a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h7zM4 18h5V6H4v12zM21 4a1 1 0 011 1v9a1 1 0 01-1 1h-7a1 1 0 01-1-1V5a1 1 0 011-1h7zm-6 9h5V6h-5v7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};